import React from "react";

class NavBar extends React.Component {
  render() {
    return (
      <React.Fragment>
        <div id="main-nav" className="navbar navbar-fixed-top">
          <div className="container">
            <div className="navbar-header">
              <button
                type="button"
                className="navbar-toggle"
                data-toggle="collapse"
                data-target="#site-nav"
              >
                <span className="icon-bar"></span>
                <span className="icon-bar"></span>
                <span className="icon-bar"></span>
              </button>

              <a className="navbar-brand scrollto" href="#home">
                <i className="fa fa-scissors "></i>
                Shawn Douglas
              </a>
            </div>

            <div id="site-nav" className="navbar-collapse collapse">
              <ul className="nav navbar-nav navbar-right">
                <li className="sr-only">
                  <a href="#home" className="scrollto">
                    Home
                  </a>
                </li>
                <li>
                  <a href="#services" className="scrollto">
                    What I Do
                  </a>
                </li>
                <li>
                  <a href="#about" className="scrollto">
                    About Me
                  </a>
                </li>
                <li>
                  <a href="#contact" className="scrollto">
                    Contact Me
                  </a>
                </li>
                <li>
                  <a href="#portfolio" className="scrollto">
                    My Work
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </React.Fragment>
    );
  }
}
export default NavBar;
